import React, { Component } from 'react';
import LoadingImage from '../assets/img/loading1.gif';

export default class Loading extends Component {
  render() {
    return (
      <div
        style={{
          width: '100p%',
          height: 400,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <img src={LoadingImage} alt="" />
          <p>cargando</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading.js